module.exports = __webpack_public_path__ + "files/1ca1b63ce93fa2a4eb9722f89794bb83.png";